import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobsPanelComponent } from '@bp2s/layout/jobs-panel/jobs-panel.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [JobsPanelComponent],
  imports: [
    CommonModule,
    MatListModule,
    RouterModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  exports: [JobsPanelComponent]
})
export class JobsPanelModule { }

